/**
 * Created by m.igrachev on 8/16/2017.
 */
export default function(toValidate, options = {}) {
    let maxSize = options.maxSize;
    if (toValidate === null || toValidate === undefined || !toValidate.length) return true;
    if (typeof maxSize !== "number") return true;

    let toValidateType = extractType(toValidate);

    switch (toValidateType) {
        case "number":
            return checkNumberSize(toValidate, maxSize);
        case "string":
            return checkStringSize(toValidate, maxSize);
        case "array":
            return manageArrayValidation(toValidate, maxSize);
        case "file":
            return checkObjectSize(toValidate, maxSize);
        case "object":
            return checkObjectSize();
        default:
            return true;
    }
}

function checkNumberSize(number, maxSize) {
    return checkStringSize(number, maxSize);
}
function checkStringSize(string, maxSize) {
    return string.length <= maxSize;
}
function checkObjectSize(object, maxSize) {
    return object.size <= maxSize;
}
function manageArrayValidation(array, maxSize) {
    //Note that we can validate only arrays of identical items.
    //Otherwise considering how to interpret maxSize is impossible.
    let itemsType = extractType(array[0]);
    //Arrays of files or objects with property size are considered special!
    if (itemsType === "file" || (itemsType === "object" && array[0].hasOwnProperty("size"))) {
        let accumulatedSize = 0;
        array.forEach(item => {
            if (item.size) {
                accumulatedSize += item.size;
            }
        });

        return accumulatedSize <= maxSize;
    }

    return array.length <= maxSize;
}

function extractType(argument) {
    if (typeof argument === "number") return "number";
    if (typeof argument === "string") return "string";
    if (typeof argument === undefined) return undefined;

    if (typeof argument === "object") {
        if (argument.constructor === Array) return "array";
        if (argument.constructor === File) return "file";

        return "object";
    }

    return undefined; //Just for clarity.
}
